export const DELIVERY = '/delivery';
export const PAYMENT = '/payment';
export const CHANGE = '/obmen_i_vozvrat';
export const Q_AND_A = '/voprosi_i_otveti';

export const KEYS = {
  DELIVERY: 'DELIVERY',
  PAYMENT: 'PAYMENT',
  CHANGE: 'CHANGE',
  Q_AND_A: 'Q_AND_A',
};

export const URL_MAP = {
  DELIVERY,
  PAYMENT,
  CHANGE,
  Q_AND_A,
};

export const URL_METHOD_MAP = {
  [DELIVERY]: 'deliveryLinkClick',
  [PAYMENT]: 'paymentLinkClick',
  [CHANGE]: 'refoundChangeLinkClick',
  [Q_AND_A]: 'QALinkClick',
};
